var crPickupCallback = function(timepicker, selectedStore, selectedDay, selectedDate, selectedMonth) {
  console.log(selectedDay, selectedDate, selectedMonth);
  if(selectedDate.getDate() === 24 && selectedMonth === 11 && selectedDate.getFullYear() === 2024) {  	
    //timepicker.set('min',[13, 0]); 
    timepicker.set('max',[16, 0]);
  }	
}